import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68b7ccc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-5" }
const _hoisted_2 = { class: "row row-cols-2 g-5 my-4" }
const _hoisted_3 = {
  key: 0,
  class: "row row-cols-2 g-5 my-4"
}
const _hoisted_4 = {
  key: 1,
  class: "row row-cols-2 g-5"
}
const _hoisted_5 = { class: "d-flex gap-1" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "row row-cols-2 g-5" }
const _hoisted_8 = { class: "row row-cols-2 g-5" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-danger" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-danger" }

import { ref, reactive, nextTick } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import type { FormInstance } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import EventServices from "../../services/EventsServices";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import ImageUploader from "quill-image-uploader";
import BlotFormatter from "quill-blot-formatter/dist/BlotFormatter";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import {
  EventShopItemCategoryOptions,
  EventShopItemCategory,
  EventShopItemTypes,
  RewardTypesOptions,
  EventShopRewardTypes,
  RewardRolesOptions,
} from "@/core/types/shop/ShopItemTypes";
import UploadImageGuid from "./UploadImageGuid.vue";
import type { TabsPaneContext } from "element-plus";
import { AccessRoles } from "@/core/types/shop/ShopEventRoles";
import Decimal from "decimal.js";
import { Check } from "@element-plus/icons-vue";
import { ConfigSiteTypesSelections } from "@/core/types/SiteTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditItem',
  props: {
    categoryData: {},
    getCategoryName: {}
  },
  emits: ["submit"],
  setup(__props: any, { expose: __expose, emit: emits }) {

const props = __props;





const isSubmitting = ref(false);
const modalRef = ref<InstanceType<typeof SimpleForm>>();
const langOptions = ref(LanguageTypes.all);
const langItem = ref<any>("");
const contentList = ref({});
const uploadImageRef = ref<any>(null);
const uploadBannerRef = ref<any>(null);
const ruleFormRef = ref<FormInstance>();
const showImageError = ref(false);
const isContentEmpty = ref(false);
const imageList = ref<any>([]);
const pointsInDollar = ref(0);
const rules = reactive<any>({
  name: [
    { required: true, message: "Please input item name", trigger: "blur" },
  ],
  title: [
    { required: true, message: "Please input item title", trigger: "blur" },
  ],
  description: [
    {
      required: true,
      message: "Please input item description",
      trigger: "blur",
    },
  ],
});

const tab = ref(1);

const tabList = ref<any>([
  { label: "Content", value: 1 },
  { label: "Detail", value: 2 },
]);

const changeTab = (tab: TabsPaneContext, event: Event) => {
  tab.value = tab.props.name;
};

const accessRoles = AccessRoles;

const formData = ref<any>({
  point: 1,
  name: "",
  type: EventShopItemTypes.Product,
  category: EventShopItemCategory.bcrMerch,
  accessRoles: ["Client", "IB", "Sales"],
  accessSites: [],
  description: "",
  language: "en-us",
  configuration: {
    validPeriodInDays: 0,
    rewardType: EventShopRewardTypes.Point1000,
  },
});
const languageFormData = ref<any>({});

const show = async (_item: any) => {
  fetchData(_item.id);
  modalRef.value?.show();
};

const fetchData = async (id: number) => {
  isSubmitting.value = true;
  try {
    await EventServices.queryShopItemById(id).then((res) => {
      formData.value = res;
      console.log("formData", formData.value);
      pointsInDollar.value = new Decimal(formData.value.point)
        .div(10000)
        .toNumber();
    });
    await fetchContent();
  } catch (error) {
    console.log(error);
  } finally {
    isSubmitting.value = false;
  }
};

const fetchContent = async () => {
  langItem.value = formData.value.languageList[0].language;
  languageFormData.value = formData.value.languageList[0];

  await fetchImage(languageFormData.value);
  await nextTick();
  fetchBannerImage();
  const contents = formData.value.languageList;
  for (let i = 0; i < contents.length; i++) {
    contentList.value[contents[i].language] = contents[i];
    languageExists(contents[i].language);
  }
};

const languageExists = (lang: string) => {
  let item = langOptions.value.find((item) => item.code == lang);
  if (item) {
    item.isAdded = true;
  }
};

const fetchBannerImage = async () => {
  if (formData.value.configuration.bannerImages) {
    const bannerImageGuid = formData.value.configuration.bannerImages[0];
    uploadBannerRef.value.uploading = true;
    const bannerImageUrl = await EventServices.getImagesWithGuid(
      bannerImageGuid
    );
    uploadBannerRef.value.imageUrl = bannerImageUrl;
    uploadBannerRef.value.uploading = false;
  }
};
const fetchImage = async (data: any) => {
  if (data.images.length > 0) {
    if (imageList.value[langItem.value]) {
      await uploadImageRef.value.handleRemove();
      uploadImageRef.value.imageUrl = imageList.value[langItem.value];
      return;
    }
    uploadImageRef.value.uploading = true;
    const imageUrl = await EventServices.getImagesWithGuid(data.images[0]);
    imageList.value[langItem.value] = imageUrl;
    uploadImageRef.value.imageUrl = imageUrl;
    uploadImageRef.value.uploading = false;
  } else {
    uploadImageRef.value.imageUrl = "";
    uploadImageRef.value.handleRemove();
  }
};
const switchLang = (lang: string) => {
  if (langItem.value == lang) return;
  langItem.value = lang;
  const item = contentList.value[lang];
  if (item == null || item == undefined) {
    contentList.value[lang] = {
      name: "",
      title: "",
      description: "<p>content</p>",
      images: [],
    };
    languageFormData.value = contentList.value[lang];
  } else {
    languageFormData.value = item;
  }
  fetchImage(languageFormData.value);
};

const checkContent = () => {
  if (languageFormData.value.description == "<p>content</p>") {
    isContentEmpty.value = true;
  } else {
    isContentEmpty.value = false;
  }
};

const submit = async () => {
  isSubmitting.value = true;
  if (tab.value === 1) {
    await checkContent();
    if (isContentEmpty.value) {
      isSubmitting.value = false;
      return;
    }
    await submitLanguage();
  } else {
    await uploadBannerImage();
    await submitDetail();
  }
  isSubmitting.value = false;
};

const uploadBannerImage = async () => {
  if (formData.value.type == EventShopItemTypes.Product) return;
  await uploadBannerRef.value?.uploadImage().then(() => {
    if (uploadBannerRef.value?.imageUrls.length > 0) {
      formData.value.configuration.bannerImages =
        uploadBannerRef.value?.imageUrls;
    }
  });
};

const submitLanguage = async () => {
  if (!ruleFormRef.value) return;

  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) return;

  try {
    languageFormData.value.eventId = formData.value.eventId;
    languageFormData.value.name = languageFormData.value.title;

    await uploadImageRef.value?.uploadImage().then(() => {
      if (uploadImageRef.value?.imageUrls.length > 0) {
        languageFormData.value.images = uploadImageRef.value?.imageUrls;
        showImageError.value = false;
      }
    });
    await EventServices.updateItemLanguage(
      formData.value.id,
      langItem.value,
      languageFormData.value
    );
    languageExists(langItem.value);
    MsgPrompt.success(langItem.value + " updated successfully");
  } catch (error) {
    console.log(error);
    MsgPrompt.error(langItem.value + " update failed");
  }
  emits("submit");
};

const submitDetail = async () => {
  try {
    formData.value.point = new Decimal(pointsInDollar.value)
      .times(10000)
      .toNumber();
    await EventServices.updateItem(formData.value.id, formData.value);
    MsgPrompt.success("Item updated successfully");
  } catch (error) {
    console.log(error);
    MsgPrompt.error("Item update failed");
  }
  emits("submit");
};

const hide = () => {
  modalRef.value?.hide();
  formData.value = {
    point: 1,
    name: "",
    type: EventShopItemTypes.Product,
    category: EventShopItemCategory.bcrMerch,
    accessRoles: ["Client", "IB", "Sales"],
    description: "",
    language: "en-us",
    configuration: {
      validPeriodInDays: 0,
      rewardType: EventShopRewardTypes.Point1000,
    },
  };
  languageFormData.value = {};
  showImageError.value = false;
  contentList.value = {};
  imageList.value = [];
  if (uploadImageRef.value) {
    uploadImageRef.value.imageUrl = "";
  }
  if (uploadBannerRef.value) {
    uploadBannerRef.value.imageUrl = "";
  }

  langItem.value = "";
  pointsInDollar.value = 0;
  langOptions.value.forEach((item) => {
    item.isAdded = false;
  });
};

const uploadImg = async (file: any) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await EventServices.uploadImage(formData);
  return res["url"];
};

const modules = [
  {
    name: "imageUploader",
    module: ImageUploader,
    options: {
      upload: (file) => {
        return uploadImg(file);
      },
    },
  },
  {
    name: "blotFormatter",
    module: BlotFormatter,
  },
];

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('action.edit'),
    "is-loading": isSubmitting.value,
    submit: submit,
    "before-close": hide,
    "save-title": 
      tab.value == 1
        ? `${_ctx.$t('action.submit')} ${langItem.value}`
        : _ctx.$t('action.submitDetail')
    ,
    "submit-color": tab.value == 1 ? 'primary' : 'success',
    class: "w-1000px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_tabs, {
            modelValue: tab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
            type: "card",
            class: "demo-tabs",
            onTabClick: changeTab
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: index,
                  label: item.label,
                  name: item.value,
                  disabled: isSubmitting.value || uploadImageRef.value.uploading
                }, null, 8, ["label", "name", "disabled"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _withDirectives(_createVNode(_component_el_form, {
            model: formData.value,
            "label-position": "top",
            class: "mb-10"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('fields.points'),
                  prop: "point"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: pointsInDollar.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pointsInDollar).value = $event)),
                      min: 1,
                      disabled: isSubmitting.value
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('fields.role'),
                  prop: "accessRoles"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox_group, {
                      modelValue: formData.value.accessRoles,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.accessRoles) = $event)),
                      min: 1,
                      disabled: isSubmitting.value
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accessRoles), (role, index) => {
                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                            key: index,
                            label: role.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(role.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              (formData.value.type == _unref(EventShopItemTypes).Product)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('fields.category'),
                      prop: "category"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formData.value.category,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.category) = $event)),
                          class: "w-200px",
                          disabled: isSubmitting.value
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.categoryData, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: props.getCategoryName(item.value),
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('fields.sites'),
                      prop: "accessSites"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: formData.value.accessSites,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.accessSites) = $event)),
                          disabled: isSubmitting.value
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (site, index) => {
                              return (_openBlock(), _createBlock(_component_el_checkbox, {
                                key: index,
                                label: site.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(site.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.cardPointsLevel'),
                        prop: "rewardTypes"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: formData.value.configuration.rewardType,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.configuration.rewardType) = $event)),
                            class: "w-200px",
                            disabled: isSubmitting.value
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RewardTypesOptions), (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.rewardRoles'),
                        prop: "type"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: formData.value.type,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.type) = $event)),
                            class: "w-200px",
                            disabled: isSubmitting.value
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RewardRolesOptions), (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.validDays')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            modelValue: formData.value.configuration.validPeriodInDays,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.configuration.validPeriodInDays) = $event)),
                            disabled: isSubmitting.value
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.sites'),
                        prop: "accessSites"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox_group, {
                            modelValue: formData.value.accessSites,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.accessSites) = $event)),
                            disabled: isSubmitting.value
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (site, index) => {
                                return (_openBlock(), _createBlock(_component_el_checkbox, {
                                  key: index,
                                  label: site.value,
                                  value: site.value
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(site.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('action.uploadBannerImage'),
                        prop: "image"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(UploadImageGuid, {
                            ref_key: "uploadBannerRef",
                            ref: uploadBannerRef
                          }, null, 512)
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ])
                  ]))
            ]),
            _: 1
          }, 8, ["model"]), [
            [_vShow, tab.value == 2]
          ]),
          _withDirectives(_createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: languageFormData.value,
            rules: rules,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('fields.language'),
                prop: "language"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: langItem.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((langItem).value = $event)),
                    disabled: isSubmitting.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langOptions.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_radio_button, {
                          key: item.code,
                          label: item.code,
                          onClick: ($event: any) => (switchLang(item.code))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("div", null, _toDisplayString(item.code), 1),
                              (item.isAdded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Check))
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["label", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('fields.itemTitle'),
                  prop: "title"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: languageFormData.value.title,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((languageFormData.value.title) = $event)),
                      disabled: isSubmitting.value
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('action.uploadCoverImage'),
                  prop: "image"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(UploadImageGuid, {
                        ref_key: "uploadImageRef",
                        ref: uploadImageRef
                      }, null, 512),
                      (showImageError.value == true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("error.fieldIsRequired")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                (formData.value.type != _unref(EventShopItemTypes).Product)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('fields.content'),
                prop: "description"
              }, {
                default: _withCtx(() => [
                  (isContentEmpty.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("tip.contentIsRequired")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _createVNode(_unref(QuillEditor), {
                      theme: "snow",
                      content: languageFormData.value.description,
                      "onUpdate:content": _cache[11] || (_cache[11] = ($event: any) => ((languageFormData.value.description) = $event)),
                      modules: modules,
                      contentType: "html",
                      toolbar: "full",
                      enable: !isSubmitting.value
                    }, null, 8, ["content", "enable"])
                  ])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["model", "rules"]), [
            [_vShow, tab.value == 1]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading", "save-title", "submit-color"]))
}
}

})